import { SavingsProfile } from "../../../types/SavingsProfile";
import DynamicText from "../../common/DynamicText";
import { FormattedValue, SimpleTable } from "frno-react";
import useTextStore from "../../../state/TextStore";
import { convertToPercentValue, getPostfix } from "../../../util/data-helper";

type SavingsProfileInformationTableProps = {
  savingsProfile: SavingsProfile;
};

type SavingsProfileTableRowData = {
  textKey: string;
  value: number | string;
  postfix?: string;
};

export default function SavingsProfileInformationTable({
  savingsProfile,
}: SavingsProfileInformationTableProps) {
  const { getTextByKey } = useTextStore();

  const UNKNOWN_VALUE = getTextByKey("unknown.value");

  function generateTableData(savingsProfile: SavingsProfile) {
    const shareRatio = savingsProfile.actualShareRatio;
    const standardDeviation = savingsProfile.standardDeviation5yr;
    const currencyHedgingRatio = savingsProfile.targetCurrencyHedgingRatio;

    const tableData: SavingsProfileTableRowData[] = [
      {
        textKey:
          "page.savingsprofiles.table.expandedrow.profileinfo.shareratio",
        value: convertToPercentValue(shareRatio, UNKNOWN_VALUE),
        postfix: getPostfix(shareRatio),
      },
      {
        textKey:
          "page.savingsprofiles.table.expandedrow.profileinfo.standarddeviation",
        value: convertToPercentValue(standardDeviation, UNKNOWN_VALUE),
        postfix: getPostfix(standardDeviation),
      },
      {
        textKey:
          "page.savingsprofiles.table.expandedrow.profileinfo.rebalancetime",
        value: savingsProfile.profileWeightRebalanceTime,
      },
      {
        textKey:
          "page.savingsprofiles.table.expandedrow.profileinfo.currencyhedgingratio",
        value: convertToPercentValue(currencyHedgingRatio, UNKNOWN_VALUE),
        postfix: getPostfix(currencyHedgingRatio),
      },
    ];

    return Object.values(tableData).map((item, index) => {
      return {
        columns: [
          { content: <DynamicText key={index} textKey={item.textKey} /> },
          {
            content: (
              <FormattedValue
                key={index}
                value={item.value}
                postfix={item.postfix}
              />
            ),
          },
        ],
      };
    });
  }

  return <SimpleTable rows={generateTableData(savingsProfile)} />;
}
